import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import $ from 'jquery'
import CustomBracketModal from '../custom-bracket/modal.component.jsx'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import BillingMethodPricingBracketLabel from "../../billing-method/pricingbracketslabel.component.jsx"
import BillingMethodCostLabel from "../../billing-method/costlabel.component.jsx"
import MoneyInputForm from "../../../common/form/moneyinput.component.jsx"
import BillingMethodPriceLabel from "../../billing-method/pricelabel.component.jsx"
import PricingHelper from '../../PricingHelper.jsx';
import GlobalHelper from '../../../common/GlobalHelper.jsx';
const uuidv4 = require('uuid/v4')

class MatrixTableEditForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            modal: '',
            defaultUnitPrice: this.props.defaultUnitPrice || '',
            defaultUnitCost: this.props.defaultUnitCost || '',
            pricingStrategy: this.props.pricingStrategy || '',
            currency: this.props.currency || '',
            currentCurrency: AppContext.getAccount().attributes.currency,
            billingMethods: this.props.billingMethods || [],
            customBracketModal: '',
            yAxis: {},
            xAxis: {},
            items: [],
        }
        this.product = this.props.product
        this.matrix = this.props.matrix
        this.onChange = this.props.onChange
        this.handleCloseCustomBracketModal = this.handleCloseCustomBracketModal.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currency: nextProps.currency || '',
            pricingStrategy: nextProps.pricingStrategy || '',
            billingMethods: nextProps.billingMethods || [],
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    getItem(xId, yId) {
        const items = this.state.items.filter(item => {
            if (item.yMatrixAxisOptionId === yId && item.xMatrixAxisOptionId === xId) {
                return true
            } else {
                return false
            }
        })
        if (items.length > 0) {
            return items[0]
        } else {
            return null
        }
    }

    sortOptions(array) {
        array.sort((optionA, optionB) => {
            if (optionA.orderBy < optionB.orderBy) {
                return -1;
            }
            if (optionA.orderBy > optionB.orderBy) {
                return 1;
            }
            return 0;
        })
        return array
    }

    loadAxis(axis) {
        let a = {
            name: this.matrix.attributes[axis + "Axis"].name,
            options: []
        }
        for (let index in this.matrix.attributes[axis + "Axis"].options) {
            const option = this.matrix.attributes[axis + "Axis"].options[index]
            a.options.push({
                id: option.id,
                name: option.attributes.name,
                orderBy: option.attributes.orderBy,
            })
        }
        a.options = this.sortOptions(a.options)
        return a

    }

    loadItems() {
        let items = []
        for (let i in this.matrix.attributes.items) {
            const item = this.matrix.attributes.items[i]

            items.push({
                unitPrice: item.attributes.product.attributes.defaultUnitPrice,
                unitCost: item.attributes.product.attributes.defaultUnitCost,
                monthlyUnitPrice: item.attributes.product.attributes.monthlyUnitPrice,
                monthlyUnitCost: item.attributes.product.attributes.monthlyUnitCost,
                yearlyUnitPrice: item.attributes.product.attributes.yearlyUnitPrice,
                yearlyUnitCost: item.attributes.product.attributes.yearlyUnitCost,
                multiCurrencyPricing: item.attributes.product.attributes.multiCurrencyPricing.map(a => {
                    return {
                        currency: a.attributes.currency,
                        oneTimePrice: a.attributes.oneTimePrice,
                        monthlyPrice: a.attributes.monthlyPrice,
                        yearlyPrice: a.attributes.yearlyPrice,
                    }
                }),
                pricingBrackets: item.attributes.product.attributes.pricingBrackets.map(bracket => {
                    return {
                        id: bracket.id,
                        fromMeasure: bracket.attributes.fromMeasure,
                        toMeasure: bracket.attributes.toMeasure,
                        cost: bracket.attributes.cost,
                        price: bracket.attributes.price,
                        monthlyCost: bracket.attributes.monthlyCost,
                        monthlyPrice: bracket.attributes.monthlyPrice,
                        yearlyCost: bracket.attributes.yearlyCost,
                        yearlyPrice: bracket.attributes.yearlyPrice,
                        sequence: bracket.attributes.sequence,
                        multiCurrencyPricing: bracket.attributes.multiCurrencyPricing.map(a => {
                            return {
                                currency: a.attributes.currency,
                                oneTimePrice: a.attributes.oneTimePrice,
                                monthlyPrice: a.attributes.monthlyPrice,
                                yearlyPrice: a.attributes.yearlyPrice,
                            }
                        }),
                    }
                }),
                yMatrixAxisOptionId: item.attributes.yMatrixAxisOptionId,
                xMatrixAxisOptionId: item.attributes.xMatrixAxisOptionId,
            })
        }
        return items
    }

    componentDidMount() {
        let newState = {
            yAxis: this.loadAxis('y'),
            xAxis: this.loadAxis('x'),
            items: this.loadItems(),
        }

        const formattedMatrixState = {
            yAxis: this.loadAxis('y'),
            xAxis: this.loadAxis('x'),
            items: this.loadItems(),
        }

        //fix format of matrix state in parent component (ProductEditForm)
        this.onChange(formattedMatrixState)

        for (let index in newState.xAxis.options) {
            newState["option-name-" + newState.xAxis.options[index].id] = newState.xAxis.options[index].name
        }
        for (let index in newState.yAxis.options) {
            newState["option-name-" + newState.yAxis.options[index].id] = newState.yAxis.options[index].name
        }
        for (let index in newState.items) {
            const uniqueId = newState.items[index].xMatrixAxisOptionId + "_" + newState.items[index].yMatrixAxisOptionId
            newState["item-one-time-cost-" + uniqueId] = newState.items[index].unitCost
            newState["item-monthly-cost-" + uniqueId] = newState.items[index].monthlyUnitCost
            newState["item-yearly-cost-" + uniqueId] = newState.items[index].yearlyUnitCost
            newState["item-one-time-price-" + uniqueId] = newState.items[index].unitPrice
            newState["item-monthly-price-" + uniqueId] = newState.items[index].monthlyUnitPrice
            newState["item-yearly-price-" + uniqueId] = newState.items[index].yearlyUnitPrice
            newState["item-multi-currency-" + uniqueId] = newState.items[index].multiCurrencyPricing
        }

        this.setState(newState)
    }

    onStateChange() {
        const matrix = {
            yAxis: this.state.yAxis,
            xAxis: this.state.xAxis,
            items: this.state.items,
        }
        this.onChange(matrix)
    }

    newItem(x, y) {
        return function (event) {
            let items = this.state.items
            const defaultPrice = ''
            const defaultCost = ''
            items.push({
                pricingBrackets: [],
                multiCurrencyPricing: [],
                unitPrice: defaultPrice,
                unitCost: defaultCost,
                monthlyUnitPrice: defaultPrice,
                monthlyUnitCost: defaultCost,
                yearlyUnitPrice: defaultPrice,
                yearlyUnitCost: defaultCost,
                xMatrixAxisOptionId: x,
                yMatrixAxisOptionId: y,
            })
            const uniqueId = x + "_" + y

            this.setState({
                items: items,
                ["item-one-time-cost-" + uniqueId]: defaultCost,
                ["item-monthly-cost-" + uniqueId]: defaultCost,
                ["item-yearly-cost-" + uniqueId]: defaultCost,
                ["item-one-time-price-" + uniqueId]: defaultPrice,
                ["item-monthly-price-" + uniqueId]: defaultPrice,
                ["item-yearly-price-" + uniqueId]: defaultPrice,
                ["item-multi-currency-" + uniqueId]: [],
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    deleteItem(x, y) {
        return function (event) {
            let items = this.state.items
            const index = items.findIndex(item => item.xMatrixAxisOptionId === x && item.yMatrixAxisOptionId === y)
            items.splice(index, 1);
            const uniqueId = x + "_" + y
            this.setState({
                ["item-one-time-cost-" + uniqueId]: undefined,
                ["item-monthly-cost-" + uniqueId]: undefined,
                ["item-yearly-cost-" + uniqueId]: undefined,
                ["item-one-time-price-" + uniqueId]: undefined,
                ["item-monthly-price-" + uniqueId]: undefined,
                ["item-yearly-price-" + uniqueId]: undefined,
                ["item-multi-currency-" + uniqueId]: undefined,
                items: items,
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    newOption(axis) {
        return function (event) {
            let a = this.state[axis + "Axis"]
            const optionId = uuidv4()
            const name = $('#new-' + axis + '-name').val()

            a.options = this.sortOptions(a.options)
            const lastOption = a.options[a.options.length - 1]
            const orderBy = lastOption ? lastOption.orderBy + 1 : 0
            a.options.push({
                id: optionId,
                name: $('#new-' + axis + '-name').val(),
                orderBy: orderBy,
            })
            this.setState({
                [axis + "Axis"]: a,
                ["option-name-" + optionId]: name,
            }, this.onStateChange)
            $('#new-' + axis + '-name').val("")
            event.preventDefault()
        }.bind(this)
    }

    editOption(axis, optionId) {
        return function (event) {
            const value = event.target.value;
            const name = event.target.name;
            let a = this.state[axis + "Axis"]
            const index = a.options.findIndex(option => option.id === optionId)
            a.options[index].name = value

            this.setState({
                [axis + "Axis"]: a,
                [name]: value
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    deleteOption(axis, optionId) {
        return function (event) {
            let a = this.state[axis + "Axis"]
            for (let index in a.options) {
                if (a.options[index].id === optionId) {
                    a.options.splice(index, 1);
                }
            }

            let items = this.state.items
            for (let index in items) {
                if (items[index][axis + "MatrixAxisOptionId"] === optionId) {
                    items.splice(index, 1);
                }
            }
            this.setState({
                [axis + "Axis"]: a,
                ["option-name-" + optionId]: undefined,
                items: items,
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    editAxisNames(axis) {
        return function (event) {
            const value = event.target.value
            let a = this.state[axis + "Axis"]
            a.name = value

            this.setState({
                [axis + "Axis"]: a,
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    displayHeader() {
        let headers = []
        for (let index in this.state.xAxis.options) {
            const option = this.state.xAxis.options[index]
            headers.push({
                key: option.id,
                element: <div className="input-group input-group-sm">
                    <input
                        onChange={this.editOption('x', option.id)}
                        name={"option-name-" + option.id}
                        type="text"
                        value={this.state["option-name-" + option.id]}
                        className="form-control form-control-sm"
                    />
                    <a href="#" onClick={this.deleteOption('x', option.id)} className="btn btn-danger btn-sm input-group-addon">X</a>
                </div>
            })
        }
        return headers
    }

    renderCustomBracket(key, item) {
        const items = this.state.items
        const yId = item.yMatrixAxisOptionId
        const xId = item.xMatrixAxisOptionId
        const index = items.findIndex(item => item.xMatrixAxisOptionId === xId && item.yMatrixAxisOptionId === yId)
        const pricingBrackets = items[index].pricingBrackets || []
        return <div className={"form-group row text-left"} key={key}>
            <div className="col-12">
                <div className={"row"}>
                    <div className="col-12">
                        <BillingMethodPricingBracketLabel
                            pricingBrackets={pricingBrackets}
                            pricingStrategy={this.state.pricingStrategy}
                            billingMethods={this.state.billingMethods}
                        />
                    </div>
                    <div className="col-12">
                        <div className="row pt-2 text-center">
                            <div className="col-12">
                                <a href="#"
                                    onClick={this.deleteItem(xId, yId)}
                                    className="btn btn-danger btn-sm"
                                >X</a>
                                &nbsp;
                                &nbsp;
                                <button className="btn btn-sm btn-primary" onClick={this.openCustomBracketModal(xId, yId)}>
                                    <FormattedMessage
                                        id="product.form.edit.custom_bracket_edit_btn"
                                        defaultMessage="Edit custom bracket"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    getPriceByBillingMethod(method, xId, yId) {
        return PricingHelper.getPriceByBillingMethod(method, this.state.currency, this.state.currentCurrency, this.state["item-multi-currency-" + xId + "_" + yId], {
            'one-time': this.state["item-one-time-price-" + xId + "_" + yId],
            'monthly': this.state["item-monthly-price-" + xId + "_" + yId],
            'yearly': this.state["item-yearly-price-" + xId + "_" + yId],
        })
    }

    setPriceByBillingMethod(method, price, xId, yId) {
        let suffix = method
        let priceName = suffix + "UnitPrice"
        if (method === "one-time") {
            priceName = "unitPrice"
        }
        let items = this.state.items
        const i = items.findIndex(item => item.xMatrixAxisOptionId === xId && item.yMatrixAxisOptionId === yId)
        let state = {}
        if (this.state.currency === this.state.currentCurrency) {
            items[i][priceName] = price
            state["item-" + method + "-price-" + xId + "_" + yId] = price
        } else {
            state["item-multi-currency-" + xId + "_" + yId] = PricingHelper.setPriceByBillingMethod(
                price,
                method,
                this.state.currentCurrency,
                this.state["item-multi-currency-" + xId + "_" + yId]
            )
        }
        state.items = items
        this.setState(state, this.onStateChange)
    }

    renderCostAndPrice(item) {
        const pricing = []
        for (let index in this.state.billingMethods) {
            const method = this.state.billingMethods[index]
            let suffix = method
            let costName = suffix + "UnitCost"
            let priceName = suffix + "UnitPrice"
            if (method === "one-time") {
                costName = "unitCost"
                priceName = "unitPrice"
            }


            const yId = item.yMatrixAxisOptionId
            const xId = item.xMatrixAxisOptionId

            pricing.push(<div className={"form-group row mb-0"} style={{ maxWidth: "300px" }}>
                <label className="col-12 col-form-label text-left py-0 px-4" htmlFor={costName}>
                    <BillingMethodCostLabel
                        billingMethod={method}
                        pricingStrategy={this.state.pricingStrategy}
                    />
                </label>
                <div className="col-12">
                    <MoneyInputForm
                        name={costName}
                        value={this.state["item-" + method + "-cost-" + xId + "_" + yId]}
                        onChange={(newValue) => {

                            let items = this.state.items
                            const i = items.findIndex(item => item.xMatrixAxisOptionId === xId && item.yMatrixAxisOptionId === yId)
                            items[i][costName] = newValue
                            this.setState({
                                items: items,
                                ["item-" + method + "-cost-" + xId + "_" + yId]: newValue,
                            }, this.onStateChange)
                        }}
                    />
                </div>
                <label className="col-12 col-form-label text-left py-0 px-4" htmlFor={priceName}>
                    <BillingMethodPriceLabel
                        billingMethod={method}
                        pricingStrategy={this.state.pricingStrategy}
                    />
                </label>
                <div className="col-12">
                    <MoneyInputForm
                        className={GlobalHelper.getEnabledCurrencies().length > 1 ? 'input-group-multi-currency' : ''}
                        name={priceName}
                        currency={this.state.currentCurrency}
                        value={this.getPriceByBillingMethod(method, xId, yId)}
                        multiCurrency={true}
                        onChange={(newValue) => {
                            this.setPriceByBillingMethod(method, newValue, xId, yId)
                        }}
                        onCurrencyChange={(newValue) => {
                            this.setState({ currentCurrency: newValue })
                        }}
                    />
                </div>
            </div>)

        }
        return pricing
    }

    renderPricingConfiguration(item) {
        let rows = []
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "bracket":
                rows = rows.concat(this.renderCostAndPrice(item))
                rows.push(<div className="row" key={rows.length}>
                    <div className="col-12">
                        <a href="#"
                            onClick={this.deleteItem(item.xMatrixAxisOptionId, item.yMatrixAxisOptionId)}
                            className="btn btn-danger btn-sm"
                        >X</a>
                    </div>
                </div>)
                break
            case "bracket-custom":
                rows.push(this.renderCustomBracket(rows.length, item))
                break
            case "bulk":
                rows.push(this.renderCustomBracket(rows.length, item))
                break
        }
        return rows
    }

    displayRow(yId) {
        let items = []
        for (let index in this.state.xAxis.options) {
            const option = this.state.xAxis.options[index]
            const item = this.getItem(option.id, yId)
            let object = {
                key: option.id + "_" + yId,
                element: <a href="#" onClick={this.newItem(option.id, yId)} className="btn btn-primary btn-sm">+</a>,
            }
            if (item) {
                object.element = this.renderPricingConfiguration(item)
            }
            items.push(object)

        }
        return items
    }

    displayRows() {
        let headers = []
        for (let index in this.state.yAxis.options) {
            const option = this.state.yAxis.options[index]
            headers.push({
                key: "y-" + option.id,
                header: <div className="input-group input-group-sm">
                    <input
                        onChange={this.editOption('y', option.id)}
                        name={"option-name-" + option.id}
                        type="text"
                        value={this.state["option-name-" + option.id]}
                        className="form-control form-control-sm"
                    />
                    <a href="#" onClick={this.deleteOption('y', option.id)} className="btn btn-danger btn-sm input-group-addon">X</a>
                </div>,
                items: this.displayRow(option.id)
            })
        }
        return headers
    }

    handleChangeCustomBrackets(x, y) {
        return function (value) {
            let items = this.state.items
            const index = items.findIndex(item => item.xMatrixAxisOptionId === x && item.yMatrixAxisOptionId === y)
            items[index].pricingBrackets = value
            this.setState({
                items: items
            }, this.onStateChange)
        }.bind(this)
    }

    openCustomBracketModal(x, y) {
        return function (event) {
            let items = this.state.items
            const index = items.findIndex(item => item.xMatrixAxisOptionId === x && item.yMatrixAxisOptionId === y)
            this.setState({
                customBracketModal: <CustomBracketModal
                    onClose={this.handleCloseCustomBracketModal}
                    onChange={this.handleChangeCustomBrackets(x, y)}
                    value={items[index].pricingBrackets}
                    pricingStrategy={this.state.pricingStrategy}
                    billingMethods={this.state.billingMethods}
                    currency={this.state.currency}
                />
            }, this.onStateChange)
            event.preventDefault()
        }.bind(this)
    }

    handleCloseCustomBracketModal() {
        this.setState({
            customBracketModal: ''
        })
    }

    render() {
        const headers = this.displayHeader().map(header => {
            return <th key={header.key}>
                {header.element}
            </th>
        })
        const rows = this.displayRows().map(row => {
            const items = row.items.map(item => {
                return <td key={item.key}>
                    {item.element}
                </td>
            })
            return <tr key={row.key}>
                <th key={"head-" + row.key} scope="row" className="table-secondary">{row.header}</th>
                {items}
            </tr>

        })

        return (
            <div>
                {this.state.customBracketModal}
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="xAxisName">
                        <FormattedMessage
                            id="product.matrix.form.edit.x_axis_label"
                            defaultMessage="X axis name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            id="xAxisName"
                            value={this.state.xAxis.name}
                            onChange={this.editAxisNames('x')}
                            type="text"
                            className="form-control"
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="product.matrix.form.edit.x_axis_description"
                                defaultMessage="The name of the column"
                            />
                        </small>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="yAxisName">
                        <FormattedMessage
                            id="product.matrix.form.edit.y_axis_label"
                            defaultMessage="Y axis name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            id="yAxisName"
                            value={this.state.yAxis.name}
                            onChange={this.editAxisNames('y')}
                            type="text"
                            className="form-control"
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="product.matrix.form.edit.y_axis_description"
                                defaultMessage="The name of the row"
                            />
                        </small>
                    </div>
                </div>

                <div className="row">
                    <table className="table table-bordered table-sm matrix-table">
                        <thead>
                            <tr key="y-head" className="table-secondary">
                                <th key="angle">
                                    {this.state.yAxis.name} \ {this.state.xAxis.name}
                                </th>
                                {headers}
                                <th key="new-x">
                                    <div className="input-group input-group-sm">
                                        <input id="new-x-name" type="text" placeholder="Name" className="form-control form-control-sm" />
                                        <a href="#" onClick={this.newOption('x')} className="btn btn-primary btn-sm input-group-addon">+</a>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                            <tr key="y-new">
                                <th scope="row" className="table-secondary">
                                    <div className="input-group input-group-sm">
                                        <input id="new-y-name" type="text" placeholder="Name" className="form-control form-control-sm" />
                                        <a href="#" onClick={this.newOption('y')} className="btn btn-primary btn-sm input-group-addon">+</a>
                                    </div>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default MatrixTableEditForm


// WEBPACK FOOTER //
// ./src/product/form/matrix/table.component.jsx